module.exports = __webpack_public_path__ + "img/doc-icon.b54f7334.svg";